import get from 'lodash/get';

import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
  initialState,
} from '../../utils/redux';
import { consts as imageUpdateConsts } from './communityImageUpdate';
import { consts as imageRemoveConsts } from './communityImageRemove';
import { COMMUNITIES_ACCESS_LEVELS } from '../../constants';
import { consts as communityInfoUpdateConsts } from './communityInfoUpdate';
import chatConsts from '../chatConnection/constants';

export const consts = createReqConsts('communities', 'currentCommunityInfo', [
  'UPDATE_CURRENT_COMMUNITY',
  'UPDATE_POSTS_COUNTER',
  'RESET_COMMUNITY',
  'CLEAR_USER_ROLE',
]);

export const actions = createActions(consts);

export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'communities',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['id'],
    },
  ],
});

const reqReducer = createReqReducer(consts);

export default (state = initialState, action) => {
  const { type, payload } = action;
  const defaultState = reqReducer(state, action);

  switch (type) {
    case consts.SEND: {
      return {
        ...state,
        ...initialState,
        sending: !payload.disableLoading,
        disabled: true,
      };
    }
    case consts.SUCCEED: {
      return {
        ...defaultState,
        disabled: false,
      };
    }

    case communityInfoUpdateConsts.SUCCEED:
    case consts.UPDATE_CURRENT_COMMUNITY:
      return {
        ...defaultState,
        ...payload,
      };
    case consts.CLEAR_USER_ROLE:
      return {
        ...defaultState,
        ...payload,
        currentUserRole: null,
        accessLevel: COMMUNITIES_ACCESS_LEVELS.READ_ONLY,
      };
    case consts.UPDATE_POSTS_COUNTER:
      return {
        ...defaultState,
        totalPosts: defaultState.totalPosts + 1,
      };

    case consts.RESET_COMMUNITY: {
      return initialState;
    }

    case imageRemoveConsts.SUCCEED:
    case imageUpdateConsts.SUCCEED: {
      return { ...state, ...payload };
    }

    case chatConsts.NEW_COMMUNITY_INVITE: {
      const data = get(payload, 'message.payload.data');
      const communityId = get(data, 'communityId');
      const memberInvitationId = get(data, 'notification.subject.id');

      if (communityId === state.id) {
        return {
          ...state,
          memberInvitationId,
        };
      }

      return state;
    }

    default:
      return defaultState;
  }
};



// WEBPACK FOOTER //
// ./src/redux/communities/currentCommunityInfo.js